var _rect, _g;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgManufacturing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4222_1737",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4222_1737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5641 17.17L9.31411 11.8943C9.02023 12.0216 8.72155 12.1196 8.41807 12.1885C8.11446 12.2574 7.79238 12.2918 7.45182 12.2918C6.12085 12.2918 4.98953 11.826 4.05786 10.8943C3.12606 9.96252 2.66016 8.83113 2.66016 7.50016C2.66016 7.06961 2.71495 6.65801 2.82453 6.26537C2.93398 5.87273 3.08967 5.49905 3.29161 5.14433L6.28516 8.12204L8.0737 6.3335L5.11224 3.356C5.46682 3.15405 5.838 2.99565 6.22578 2.88079C6.61356 2.76593 7.02224 2.7085 7.45182 2.7085C8.78293 2.7085 9.91432 3.17433 10.846 4.106C11.7777 5.0378 12.2435 6.16919 12.2435 7.50016C12.2435 7.85169 12.2104 8.17912 12.1441 8.48245C12.0779 8.78593 11.9785 9.07926 11.846 9.36245L17.1218 14.6125C17.2671 14.7595 17.3397 14.9373 17.3397 15.1458C17.3397 15.3543 17.2677 15.5306 17.1235 15.6747L15.6104 17.1879C15.4662 17.3319 15.2921 17.4013 15.0881 17.396C14.884 17.3906 14.7094 17.3152 14.5641 17.17ZM15.0962 15.9202L15.8589 15.1572L10.3093 9.60745C10.5432 9.31898 10.7157 8.99072 10.8268 8.62266C10.9379 8.25461 10.9935 7.88044 10.9935 7.50016C10.9935 6.576 10.6634 5.75815 10.0031 5.04662C9.34279 4.33509 8.50731 3.98627 7.49661 4.00016L9.30286 5.8062C9.45342 5.9569 9.5287 6.13266 9.5287 6.3335C9.5287 6.53433 9.45342 6.71009 9.30286 6.86079L6.81245 9.3512C6.66175 9.50176 6.48599 9.57704 6.28516 9.57704C6.08432 9.57704 5.90856 9.50176 5.75786 9.3512L3.95182 7.54495C3.95391 8.6144 4.31342 9.46461 5.03036 10.0956C5.74731 10.7264 6.55446 11.0418 7.45182 11.0418C7.81655 11.0418 8.18127 10.9876 8.54599 10.8791C8.91057 10.7708 9.24405 10.6012 9.54641 10.3704L15.0962 15.9202Z",
    fill: "currentColor"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManufacturing);
export default __webpack_public_path__ + "static/media/manufacturing.f189c495.svg";
export { ForwardRef as ReactComponent };